import { createSlice } from "@reduxjs/toolkit";
import { ClientContact } from "../../types/clients-module-types";

type ClientContactsState = {
  isLoadingContacts: boolean;
  isLoadedContacts: boolean;
  clientContacts: ClientContact[];
  actualClientId: number;
  isShowingActives: boolean;
  contactsFilterText: string;
  newUpdate: boolean;
};

const initialState: ClientContactsState = {
  isLoadingContacts: true,
  isLoadedContacts: false,
  clientContacts: [],
  actualClientId: 0,
  isShowingActives: true,
  contactsFilterText: "",
  newUpdate: false,
};

export const clientContactsSlice = createSlice({
  name: "clientContacts",
  initialState,
  reducers: {
    loadContacts: (state, action) => {
      state.actualClientId = action.payload.data.clientId;
      state.clientContacts = action.payload.data.contacts;
      state.isLoadingContacts = false;
      state.isLoadedContacts = true;
    },
    setIsLoadingContacts: (state, action) => {
      state.isLoadingContacts = action.payload;
    },
    setIsShowingActives: (state, action) => {
      state.isShowingActives = action.payload;
    },
    setContactsFilterText: (state, action) => {
      state.contactsFilterText = action.payload;
    },
    setNewUpdate: (state, action) => {
      state.newUpdate = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  loadContacts,
  setIsLoadingContacts,
  setIsShowingActives,
  setContactsFilterText,
  setNewUpdate,
} = clientContactsSlice.actions;

export const IsLoadingContacts = (state: any) => {
  return state.clientContacts.isLoadingContacts;
};

export const IsLoadedContacts = (state: any) => {
  return state.clientContacts.isLoadedContacts;
};

export const SelectClientContacts = (state: any) => {
  return state.clientContacts.clientContacts;
};

export const SelectActualClientId = (state: any) => {
  return state.clientContacts.actualClientId;
};

export const SelectIsShowingActives = (state: any) => {
  return state.clientContacts.isShowingActives;
};

export const SelectContactsFilterText = (state: any) => {
  return state.clientContacts.contactsFilterText;
};

export const SelectNewUpdated = (state: any) => {
  return state.clientContacts.newUpdate;
};

export default clientContactsSlice.reducer;
